import { Capacitor } from '@capacitor/core';

const APP_UA_TAG = 'MyTownlyCustomerApp';

/** Set by MainActivity or index.html bootstrap (server.url reports platform "web") */
export const isInjectedNativeShell = () =>
  typeof window !== 'undefined' && window.__MYTOWNLY_NATIVE_SHELL__ === true;

export const hasCustomerAppUserAgent = () => {
  if (typeof navigator === 'undefined') return false;
  return (navigator.userAgent || '').includes(APP_UA_TAG);
};

/** Play Store shell — synchronous; works before Capacitor bridge is ready */
export const isNativeCustomerShell = () =>
  isInjectedNativeShell() || hasCustomerAppUserAgent();

export const getCapacitorPlatform = () => {
  try {
    return Capacitor.getPlatform();
  } catch {
    return 'web';
  }
};

/** Android System WebView (Play Store shell) — not Chrome browser */
export const isAndroidWebView = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return /Android/i.test(ua) && (/\bwv\b/i.test(ua) || ua.includes(APP_UA_TAG));
};

/** True when Capacitor reports a native OS platform (android/ios) */
export const isCapacitorNativePlatform = () => {
  const platform = getCapacitorPlatform();
  return platform === 'android' || platform === 'ios';
};

/** True when running inside the Capacitor Android/iOS shell */
export const isNativeApp = () => isNativeCustomerShell() || isCapacitorNativePlatform() || isAndroidWebView();

/** Capacitor native bridge present (Android WebView / iOS WKWebView) */
export const hasCapacitorNativeBridge = () => {
  if (typeof window === 'undefined') return false;
  return Boolean(window.androidBridge)
    || Boolean(window.webkit?.messageHandlers?.bridge);
};

/**
 * Native Firebase phone auth — never true in a normal browser tab.
 * isPluginAvailable('FirebaseAuthentication') is true on web too (plugin has a web impl),
 * so we must not use that as a signal here.
 */
export const useNativePhoneAuth = () =>
  isNativeCustomerShell()
  || isCapacitorNativePlatform()
  || hasCapacitorNativeBridge();
